import axios from 'axios';
import { Prod01 } from '../constants/ActionType';
import { uploadFileError } from './uploadLimits';

// The access token lives in axios defaults; raw fetch() does not send it, so add it explicitly.
export const authHeaders = () => {
    const token = axios.defaults.headers.common['authorization'];
    return token ? { authorization: token } : {};
};

// Only a real File/Blob is uploaded. Forms keep `{}` as "no file chosen"; appending that to FormData sends the text
// "[object Object]" instead of a file, which the server rejects.
export const isUploadableFile = (value) => typeof Blob !== 'undefined' && value instanceof Blob;

const post = async (endpoint, field, file) => {
    const problem = uploadFileError(file);
    if (problem) throw new Error(problem);
    const formData = new FormData();
    formData.append(field, file);
    const res = await fetch(`${Prod01}/general/${endpoint}`, { method: 'POST', headers: authHeaders(), body: formData });
    let body = {};
    try { body = await res.json(); } catch (e) { body = {}; }
    if (!res.ok || !body.filename) {
        throw new Error(`File upload failed: ${body.message || `server responded ${res.status}`}`);
    }
    return body; // { filename: <stored unique name>, originalName }
};

export const uploadImage = (image) =>
    isUploadableFile(image) ? post('images', 'image', image) : Promise.reject(new Error('Choose an image file first.'));

// optional attachment: no file -> nothing uploaded (record saved without a file, as before)
export const uploadDocument = (file) =>
    isUploadableFile(file) ? post('uploadfile', 'file', file) : Promise.resolve({ filename: null, originalName: null });
